<script setup>
/* eslint-disable */
import SharedInput from "@/components/shared/SharedInput.vue";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import ProjectsService from "@/api/services/projects.service";
import DepartmentService from "@/api/services/department.service";
import Notification from "@/utils/plugins/NotificationService";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useUiStore } from "@/app/stores/uiStore";

import EmployeeService from '@/api/services/employee.service';
import { ElMessageBox } from "element-plus";

const props = defineProps({
  project: {
    type: Object,
    required: true,
  },
  isNew: {
    type: Boolean,
    default: false,
  },
  lockedClientId: {
    type: [String, Number],
    default: null,
  },
});
const uiStore = useUiStore();
const router = useRouter();
const emits = defineEmits(['change', 'add-document', 'delete']);
const isDisable = ref(false);
const optionsClient = ref([]);
const optionsType = ref([]);
const optionsDepartment = ref([]);

const showModalAddEmployee = ref(false);
const showModalEmployees = ref(false);
const selectedProjectList = ref({
  employees: [],
});

const listAllEmployees = ref([]);
const allEmployeesListTotal = ref(0);
const page = ref(1);
const itemsPerPage = ref(10);
const params = ref({});
const searchNameModalEmployees = ref('');

const projectModel = ref(null)
const projectHeaderName = ref('')
const initialOwnerDepartmentResource = ref(null)
const createContractedTime = ref('')
const createSubmitAttempted = ref(false)
const optionsReviewPeriod = [
  { id: 0, name: "no revisar", value: 0 },
  { id: 1, name: "cada mes", value: 1 },
  { id: 2, name: "cada 2 meses", value: 2 },
  { id: 3, name: "cada 3 meses", value: 3 },
  { id: 4, name: "cada 4 meses", value: 4 },
  { id: 5, name: "cada 5 meses", value: 5 },
  { id: 6, name: "cada 6 meses", value: 6 },
];
const optionsSource = [
  { label: 'Connectus', value: 'connectus' },
  { label: 'Clockify', value: 'clockify' },
];

const documentProposal = ref([]);
const documentEstimate = ref([]);
const project = computed(() => {
  return props.project;
})
const isCreateMode = computed(() => props.isNew)
const hasLockedClient = computed(() => isCreateMode.value && !!props.lockedClientId)
const isClientLocked = computed(() => hasLockedClient.value && !!projectModel.value?.client)
const projectSource = computed(() => String(projectModel.value?.source || '').trim().toLowerCase())
const projectTypeName = computed(() => String(projectModel.value?.projectType?.name || projectModel.value?.projectType || '').trim().toUpperCase())
const canEditTopFields = computed(() => isCreateMode.value || projectSource.value === 'connectus')
const canEditProjectConfigFields = computed(() => canEditTopFields.value || projectSource.value === 'clockify')
const canEditClientField = computed(() => canEditTopFields.value && !isClientLocked.value)
const isConnectusBhProject = computed(() => projectSource.value === 'connectus' && projectTypeName.value === 'BH')
const canEditContractedHours = computed(() => isCreateMode.value || projectSource.value === 'connectus')
const isBhType = computed(() => projectTypeName.value === 'BH' && (isCreateMode.value || projectSource.value === 'connectus'))
const bhNameError = ref('')
const canShowDeleteProject = computed(() => {
  const timeEntries = projectModel.value?.timeEntries
  const hasNoTimeEntries = timeEntries === undefined || (Array.isArray(timeEntries) && timeEntries.length === 0)
  return !isCreateMode.value && projectModel.value?.source === 'connectus' && hasNoTimeEntries
})
const hasProjectField = (field) => {
  return projectModel.value && Object.prototype.hasOwnProperty.call(projectModel.value, field)
}
const hasLastReviewDate = computed(() => {
  return !!projectModel.value?.lastReviewDate
})
const hasExpiredDeadline = computed(() => projectModel.value?.deadline === true)

const syncProjectState = (projectData) => {
  projectModel.value = projectData;
  projectHeaderName.value = projectData?.name || ''
  initialOwnerDepartmentResource.value = getProjectResource(projectData?.ownerDepartment) || null
  documentEstimate.value = projectModel.value.projectEstimationDocuments || []
  documentProposal.value = projectModel.value.projectProposalDocuments || []
  createContractedTime.value = getContractedHoursLabel(projectModel.value.contractedTime)
}

watch(() => props.project, (nextProject) => {
  if (!nextProject) return
  syncProjectState(nextProject)
})

watch(projectTypeName, () => {
  if (projectModel.value?.name) {
    onNameChange(projectModel.value.name)
  } else {
    bhNameError.value = ''
  }
})

onMounted(async () => {
  syncProjectState(props.project)
  uiStore.startLoading();
  try {
    await Promise.all([getTypes(), getClients(), getDepartments()]);
    applyLockedClient();
  } finally {
    uiStore.stopLoading();
  }
})

const nrohoras = computed(() => {
  if (!projectModel.value.contractedTime) return 0.0 + " h";
  const hours = (projectModel.value.contractedTime / 3600).toFixed(2);
  return hours + " h";
})
const consumedTimePercent = computed(() => {
  if (!projectModel.value.consumedTime) return 0.0 + "%";
  if (!projectModel.value.contractedTime) return 0.0 + "%";
  const hcosumend = projectModel.value.consumedTime / 3600;
  const hcontract = projectModel.value.contractedTime / 3600;
  const porc = (hcosumend * 100) / hcontract;
  return porc ? Math.floor(porc) + "%" : 0 + "%";
})
const projectStatusLabel = computed(() => {
  switch (projectModel.value?.status) {
    case 'NO_ALERT':
    case 'no_alert':
      return 'Consumo OK'
    case 'ALERT_80':
    case 'alert_80':
      return 'Supera 80%'
    case 'ALERT_100':
    case 'alert_100':
      return 'Supera 100%'
    default:
      return projectModel.value?.status || ''
  }
})
const projectStatusClass = computed(() => {
  switch (projectModel.value?.status) {
    case 'NO_ALERT':
    case 'no_alert':
      return 'project-status-badge--ok'
    case 'ALERT_80':
      return 'project-status-badge--warning'
    case 'ALERT_100':
    case 'alert_100':
      return 'project-status-badge--danger'
    default:
      return 'project-status-badge--neutral'
  }
})
const consumedTime = computed(() => {
  const total = projectModel.value.consumedTime

  if (!total || total === 0) return "0 h"

  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)

  return `${hours}h ${minutes}m`
})
const contractedTime = computed(() => {
  if (!projectModel.value.contractedTime || projectModel.value.contractedTime === 0)
    return "0 h";

  const hours = (projectModel.value.contractedTime / 3600).toFixed(2);

  return hours + " h";
})

const parseBhHoursFromName = (name) => {
  const match = String(name ?? '').match(/[\[\(] ?(\d+) ?h? ?[\]\)]/mi)
  return match ? parseInt(match[1]) : null
}

const parseBhDateFromName = (name) => {
  const match = String(name ?? '').match(/\[ ?(\d{1,2}) ?\/ ?(\d{1,2}) ?\/ ?(\d{4}) ?\]/mi)
  if (!match) return null
  const [, day, month, year] = match
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

const validateBhName = (name) => {
  if (!isBhType.value || !canEditTopFields.value) return true
  const hours = parseBhHoursFromName(name)
  const date = parseBhDateFromName(name)
  if (!hours && !date) {
    bhNameError.value = 'El nombre BH debe incluir las horas [Xh] y la fecha [DD/MM/YYYY].'
    return false
  }
  if (!hours) {
    bhNameError.value = 'Falta el número de horas contratadas en el formato [Xh] (ej. [100h]).'
    return false
  }
  if (!date) {
    bhNameError.value = 'Falta la fecha de contratación en el formato [DD/MM/YYYY] (ej. [01/06/2024]).'
    return false
  }
  bhNameError.value = ''
  return true
}

const onNameChange = (value) => {
  if (!isBhType.value || !canEditTopFields.value) return

  const hours = parseBhHoursFromName(value)
  if (hours !== null) {
    createContractedTime.value = `${hours} h`
    projectModel.value.contractedTime = hours * 3600
  }

  const date = parseBhDateFromName(value)
  if (date !== null) {
    projectModel.value.initialDate = date
  }

  validateBhName(value)
}

const getContractedHoursFromInput = (value) => {
  const digits = String(value ?? '').match(/\d+/)
  return digits ? parseInt(digits[0]) : null
}

const getContractedHoursLabel = (value) => {
  if (!value) return ''

  const hours = Number(value) / 3600
  return Number.isInteger(hours) ? `${hours} h` : `${Math.floor(hours)} h`
}

const updateCreateContractedTime = (value) => {
  if (!canEditContractedHours.value) return
  createContractedTime.value = value
}

const normalizeCreateContractedTime = (value = createContractedTime.value) => {
  if (!canEditContractedHours.value) return

  const hours = getContractedHoursFromInput(value)

  if (hours === null) {
    createContractedTime.value = ''
    projectModel.value.contractedTime = 0
    return
  }

  createContractedTime.value = `${hours} h`
  projectModel.value.contractedTime = hours * 3600
}

const tableRowClassName = (param) => {
  if (param.rowIndex % 2 === 0) {
    console.log("warning-row", param.rowIndex);
    return "warning-row";
  } else console.log("success-row", param.rowIndex);
  return "success-row";
}
const getTypes = () => {
  return ProjectsService.getTypes()
    .then((result) => {
      optionsType.value = result.data["hydra:member"];
    })
    .catch((err) => {
      console.error("Types", err);
      Notification.addNotification(
        "Error al intentar eliminar el empleado seleccionado.",
        "error",
        6000
      );
    });
}
const getClients = () => {
  return ProjectsService.getClients()
    .then((result) => {
      optionsClient.value = result.data["hydra:member"];
    })
    .catch((err) => {
      console.error("Types", err);
      Notification.addNotification(
        "Error al intentar eliminar el empleado seleccionado.",
        "error",
        6000
      );
    });
}
const getDepartments = () => {
  return DepartmentService.getDepartments({
    page: 1,
    itemsPerPage: 9999,
    'order[name]': 'ASC',
  })
    .then((result) => {
      optionsDepartment.value = result.data["hydra:member"];
    })
    .catch((err) => {
      console.error("Departments", err);
      Notification.addNotification(
        "Error al obtener los departamentos.",
        "error",
        6000
      );
    });
}
const getResourceId = (item) => {
  const id = item?.id || item?.['@id'] || item
  if (!id) return null

  return String(id).split('/').pop()
}

const applyLockedClient = () => {
  if (!hasLockedClient.value || !projectModel.value) return

  const selectedClient = optionsClient.value.find((item) => getResourceId(item) === getResourceId(props.lockedClientId))
  if (selectedClient) {
    projectModel.value.client = selectedClient
  }
}
const onChangeObs = () => {
  isDisable.value = !!(projectModel.value && projectModel.value.observations);
}

const goBackToProjects = () => {
  router.push({ name: 'projects' });
}

const getProjectResource = (field) => field?.['@id'] || field?.id || field

const getUpdateProjectPayload = () => {
  const payload = { ...projectModel.value }
  const currentOwnerDepartmentResource = getProjectResource(projectModel.value?.ownerDepartment) || null
  const ownerDepartmentHasChanged = currentOwnerDepartmentResource !== initialOwnerDepartmentResource.value

  if (ownerDepartmentHasChanged) {
    payload.ownerDepartmentHasChanged = true
    payload.ownerDepartment = currentOwnerDepartmentResource ? projectModel.value.ownerDepartment : null
  }

  return payload
}

const validateCreateProject = () => {
  if (!projectModel.value.name || !projectModel.value.client || !projectModel.value.projectType || !projectModel.value.initialDate) {
    Notification.addNotification({
      title: 'Nuevo proyecto',
      message: 'Te faltan campos obligatorios por rellenar',
      type: 'warning',
      duration: 6000
    });
    return false
  }

  if (isBhType.value && !validateBhName(projectModel.value.name)) {
    Notification.addNotification({
      title: 'Proyecto BH',
      message: bhNameError.value,
      type: 'warning',
      duration: 8000
    });
    return false
  }

  return true
}

const showRequiredCreateField = (field) => isCreateMode.value && createSubmitAttempted.value && !field

const getCreateProjectPayload = () => {
  const payload = {
    name: projectModel.value.name,
    client: getProjectResource(projectModel.value.client),
    projectType: getProjectResource(projectModel.value.projectType),
    initialDate: projectModel.value.initialDate,
  }

  if (projectModel.value.tag) payload.tag = projectModel.value.tag
  if (projectModel.value.source) payload.source = projectModel.value.source
  if (projectModel.value.observations) payload.observations = projectModel.value.observations
  if (projectModel.value.contractedTime) payload.contractedTime = projectModel.value.contractedTime
  if (projectModel.value.ownerDepartment) payload.ownerDepartment = getProjectResource(projectModel.value.ownerDepartment)
  if (projectModel.value.reviewPeriodMonths !== null && projectModel.value.reviewPeriodMonths !== undefined) {
    payload.reviewPeriodMonths = projectModel.value.reviewPeriodMonths
  }
  if (projectModel.value.minConsumptionHours !== null && projectModel.value.minConsumptionHours !== undefined) {
    payload.minConsumptionHours = parseInt(projectModel.value.minConsumptionHours) || 0
  }

  return payload
}

const onSubmit = () => {
  normalizeCreateContractedTime()

  if (isCreateMode.value) {
    createSubmitAttempted.value = true
    if (!validateCreateProject()) return
    emits("change", getCreateProjectPayload());
    return
  }

  projectModel.value.minConsumptionHours = parseInt(projectModel.value.minConsumptionHours);
  if (projectModel.value.minConsumptionHours > (projectModel.value.contractedTime / 3600)) {
    Notification.addNotification({
      title: 'Error',
      message: 'El consumo mínimo no puede ser mayor a las horas contratadas',
      type: 'error',
      duration: 6000
    });
    projectModel.value.minConsumptionHours = 0;
  } else {
    projectHeaderName.value = projectModel.value.name || projectHeaderName.value
    emits("change", getUpdateProjectPayload());
  }
}

const onDeleteProject = async () => {
  const confirmed = await confirmDeleteProject()
  if (!confirmed) return

  // Boton preparado: la eliminacion por API se anadira cuando se defina el flujo.
}

const confirmDeleteProject = async () => {
  return ElMessageBox.confirm(
    '¿Estás seguro de eliminar el proyecto?',
    'Confirmar',
    {
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      type: 'warning',
    }
  )
    .then(() => true)
    .catch(() => false);
}

const closeModalAddEmployee = () => {
  showModalAddEmployee.value = false;
}
const addEmployeeFromConfigModal = () => {
  openModalEmployees();
}

const openModalEmployees = () => {
  getEmployees();
  showModalEmployees.value = true;
}

const getEmployees = () => {
  delete params.value.name
  params.value = {
    ...params.value,
    page: page.value,
    itemsPerPage: itemsPerPage.value,
    active: true,
  }

  uiStore.startLoading();
  EmployeeService.getEmployees(params.value)
    .then((res) => {
      uiStore.stopLoading();
      listAllEmployees.value = res.data['hydra:member'];
      allEmployeesListTotal.value = res.data['hydra:totalItems']
    })
    .catch(() => {
      uiStore.stopLoading();
      Notification.addNotification('Error al obtener los empleados', 'error', 6000);
    });
}

const filterEmployeesByName = (name) => {
  delete params.value.name;
  if (name && name.length > 0) {
    name = name.toLowerCase();

    params.value = {
      ...params.value,
      orSearch_fullName: name,
    }
  } else {
    delete params.value['orSearch_fullName']
  }

  page.value = 1;
  getEmployees();
  delete params.value.name;
}

const addEmployeeToProject = (employee) => {
  if (selectedProjectList.value != null) {
    if (selectedProjectList.value.employees) {
      let existMember = selectedProjectList.value.employees.findIndex(member => member.id === employee.id);
      if (existMember == -1) {
        selectedProjectList.value.employees.push(employee);
        Notification.addNotification({
          type: 'success',
          message: 'Empleado anadido',
          duration: 6000
        })
      } else {
        selectedProjectList.value.employees.splice(existMember, 1);
        Notification.addNotification({
          type: 'warning',
          message: 'Empleado eliminado',
          duration: 6000
        })
      }
    } else {
      selectedProjectList.value.employees.push(employee);
      Notification.addNotification({
        type: 'success',
        message: 'Empleado anadido',
        duration: 6000
      })
    }
  }
}

const requestSaveEmployeeToProject = () => {
  console.log('Aceptar')
  closeModalAddEmployee();
}

const showFile = (doc) => {
  console.log(doc);

  if (doc.contentUrl) {
    const url = process.env.VUE_APP_BASE_URI + "/" + doc.contentUrl;
    window.open(url, "_blank");
  }
}
const confirmFileAttached = async (name) => {
  try {
    await ElMessageBox.confirm(
      'Deseas borrar el archivo?',
      'Confirmar',
      {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }
    )
    await uiStore.startLoading();
    await cleanMedia(name);
    await uiStore.stopLoading();
    return true;
  } catch {
    return false;
  }
}
const cleanMedia = async (name) => {
  let id;
  if (name == "proposal") {
    id = documentProposal.value[0].id;
    documentProposal.value = [];
    projectModel.value.projectProposalDocuments = [];
    await ProjectsService.deleteProjectProposalDocument(id);
  } else {
    id = documentEstimate.value[0].id;
    documentEstimate.value = [];
    projectModel.value.projectEstimationDocuments = [];
    await ProjectsService.deleteProjectEstimationDocument(id);
  }
  await emits("delete", projectModel.value);
  return true;
}

const validateFileType = (file) => {
  const allowedTypes = {
    'application/pdf': true,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': true,
    'application/msword': true,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
    'application/vnd.ms-excel': true,
    'application/vnd.oasis.opendocument.text': true,
    'application/vnd.oasis.opendocument.spreadsheet': true
  };

  return allowedTypes[file.type] || false;
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const selectFile = async (name) => {
  if (name === "estimate") {
    if (documentEstimate.value.length > 0) {
      if (documentEstimate.value[0] && documentEstimate.value[0].name) {
        const result = await confirmFileAttached(name);
        if (!result) return;
      }
    }
  } else {
    if (documentProposal.value.length > 0) {
      if (documentProposal.value[0] && documentProposal.value[0].name) {
        const result = await confirmFileAttached(name);
        if (!result) return;
      }
    }
  }

  const fileSelector = document.createElement("input");
  fileSelector.setAttribute("type", "file");
  fileSelector.setAttribute("accept", ".pdf,.doc,.docx,.xls,.xlsx,.odt,.ods");

  fileSelector.addEventListener("change", async function (e) {
    const file = e.target.files[0];

    if (!file) return;

    const maxSize = 25 * 1024 * 1024;
    if (file.size > maxSize) {
      Notification.addNotification({
        type: 'error',
        message: `El archivo excede el tamano maximo permitido (25 MB). Tamano actual: ${formatFileSize(file.size)}`,
        duration: 10000
      });
      return;
    }

    if (!validateFileType(file)) {
      Notification.addNotification({
        type: 'error',
        message: 'Tipo de archivo no permitido. Solo se aceptan archivos PDF, Word, Excel, LibreOffice Writer y Calc.',
        duration: 10000
      });
      return;
    }

    try {
      await uiStore.startLoading();

      let formData = new FormData();
      formData.append("file", file);
      formData.append('project_id', projectModel.value.id);

      if (name === "estimate") {
        const response = await ProjectsService.postProjectEstimationDocument(formData);
        const media = response.data;
        projectModel.value.projectEstimationDocuments.push(media);
        documentEstimate.value = projectModel.value.projectEstimationDocuments;
      } else {
        const response = await ProjectsService.postProjectProposalDocument(formData);
        const media = response.data;
        projectModel.value.projectProposalDocuments.push(media);
        documentProposal.value = projectModel.value.projectProposalDocuments;
      }

      await uiStore.stopLoading();
      emits('add-document', projectModel.value);
      projectModel.value = project.value;

      Notification.addNotification({
        type: 'success',
        message: 'Archivo subido correctamente',
        duration: 6000
      });
    } catch (error) {
      await uiStore.stopLoading();
      Notification.addNotification({
        type: 'error',
        message: 'Error al subir el archivo. Por favor, intentelo de nuevo.',
        duration: 10000
      });
      console.error('Error al subir el archivo:', error);
    }
  });

  fileSelector.click();
  return false;
}

const syncProject = () => {
}
</script>

<template>
  <div v-if="projectModel">
    <div class="project-header d-flex flex-row justify-content-start my-2 label-common">
      <div class="title-text project-header__title w-75 col-10">
        <span v-if="isCreateMode" class="name-project">Nuevo proyecto</span>
        <template v-else>
          Proyecto:
          <span class="name-project"> {{ projectHeaderName || projectModel.name }} </span>
        </template>
      </div>

      <div class="form-item project-header__date col date-picker align-content-center justify-content-center ">
        <label class="project-header__date-label">
          Fecha de inicio
          <span v-if="hasExpiredDeadline" class="project-deadline-badge">Fecha de límite vencida</span>
        </label>
        <el-date-picker v-model="projectModel.initialDate" type="date" placeholder="Fecha Inicio"
          class="col project-date-picker" format="DD/MM/YYYY" :prefix-icon="'el-icon-date'"
          :class="[{ readOnlyInput: !canEditTopFields }]" :value-format="canEditTopFields ? 'YYYY-MM-DD' : undefined"
          :picker-options="{ firstDayOfWeek: 1 }" :readonly="!canEditTopFields" />
        <p v-if="showRequiredCreateField(projectModel.initialDate)" class="invalid-feedback mb-0"
          style="margin-top: 10px;">
          <small>Campo obligatorio</small>
        </p>
      </div>
    </div>

    <el-row>
      <el-card class="card-search w-100" body-style="padding:0">
        <el-row :gutter="10">
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Nombre</label>
              <el-input v-model="projectModel.name" :class="['search-input', { readOnlyInput: !canEditTopFields }]"
                :color="'light'" :placeholder="isBhType ? 'Ej: Cliente proyecto [100h] [01/01/2024]' : 'Ingrese nombre del proyecto'"
                :readonly="!canEditTopFields" @update:model-value="onNameChange" />
              <p v-if="showRequiredCreateField(projectModel.name)" class="invalid-feedback mb-0">
                <small>Campo obligatorio</small>
              </p>
              <p v-if="isBhType && canEditTopFields" class="bh-name-hint mb-0">
                <small>Formato BH: <code>[Xh]</code> para horas y <code>[DD/MM/YYYY]</code> para fecha — ej. <em>Cliente [100h] [01/06/2024]</em></small>
              </p>
              <p v-if="isBhType && canEditTopFields && bhNameError" class="invalid-feedback mb-0">
                <small>{{ bhNameError }}</small>
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">{{ isBhType ? 'Horas contratadas' : 'Horas estimadas' }}</label>
              <el-input :model-value="canEditContractedHours ? createContractedTime : contractedTime"
                :class="['search-input', { readOnlyInput: !canEditContractedHours }]" color="light" :placeholder="'0 h'"
                :readonly="!canEditContractedHours" @update:model-value="updateCreateContractedTime"
                @change="normalizeCreateContractedTime" />
            </div>
          </el-col>
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Cliente</label>
              <el-select v-model="projectModel.client"
                :class="['search-input', 'w-100', { readOnlyInput: !canEditClientField }]" color="light"
                placeholder="Todos" :value-key="'@id'" :disabled="!canEditClientField" filterable>
                <el-option v-for="item in optionsClient" :key="item.id" :label="item.name || 'Nameless'"
                  :value="item" />
              </el-select>
              <p v-if="showRequiredCreateField(projectModel.client)" class="invalid-feedback mb-0">
                <small>Campo obligatorio</small>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">{{ isCreateMode ? 'Tipo proyecto' : 'Tipo' }}</label>
              <el-select v-model="projectModel.projectType" :class="['w-100', { readOnlyInput: !canEditTopFields }]"
                color="light" placeholder="TODOS" :value-key="'@id'" :disabled="!canEditTopFields" filterable>
                <el-option v-for="item in optionsType" :key="item.id" :label="item.name" :value="item" />
              </el-select>
              <p v-if="showRequiredCreateField(projectModel.projectType)" class="invalid-feedback mb-0">
                <small>Campo obligatorio</small>
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Etiqueta</label>
              <el-input v-model="projectModel.tag"
                :class="['search-input', { readOnlyInput: !canEditProjectConfigFields }]" :color="'light'" maxlength="5"
                :placeholder="'Ingrese la etiqueta'" :readonly="!canEditProjectConfigFields" />
            </div>
          </el-col>
          <el-col v-if="!isCreateMode" :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Fuente</label>
              <el-select v-model="projectModel.source" class="search-input w-100 readOnlyInput" color="light" disabled
                placeholder="Elija la fuente">
                <el-option v-for="item in optionsSource" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Periodo de revision (Consumo mínimo)</label>
              <el-select v-model="projectModel.reviewPeriodMonths"
                :class="['w-100', { readOnlyInput: !canEditProjectConfigFields }]" color="light"
                placeholder="Periodo de revision" :disabled="!canEditProjectConfigFields">
                <el-option v-for="item in optionsReviewPeriod" :key="item.id" :label="item.name" :value="item.value" />
              </el-select>
            </div>
          </el-col>
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Consumo mínimo de horas</label>
              <el-input v-model="projectModel.minConsumptionHours"
                :class="['search-input', { readOnlyInput: !canEditProjectConfigFields }]" type="number" :color="'light'"
                :placeholder="'Numero de horas'" :readonly="!canEditProjectConfigFields" />
            </div>
          </el-col>
          <el-col :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Propietario</label>
              <el-select v-model="projectModel.ownerDepartment"
                :class="['w-100', { readOnlyInput: !canEditProjectConfigFields }]" color="light"
                placeholder="Sin definir" :value-key="'@id'" :disabled="!canEditProjectConfigFields" clearable
                filterable>
                <el-option v-for="item in optionsDepartment" :key="item.id" :label="item.name" :value="item" />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :md="6" v-if="false">
            <div class="form-item">
              <button class="btn btn_yellow btn-search mt-4" @click="syncProject">
                Sincronizar
              </button>
            </div>
          </el-col>
        </el-row>
        <el-row
          v-if="hasProjectField('billable') || hasProjectField('archived') || hasLastReviewDate || canShowDeleteProject"
          :gutter="10">
          <el-col v-if="hasProjectField('billable')" :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Facturable</label>
              <div class="project-switch-item">
                <el-switch v-model="projectModel.billable" active-text="Si" inactive-text="No"
                  :disabled="!canEditProjectConfigFields" />
              </div>
            </div>
          </el-col>
          <el-col v-if="hasProjectField('archived')" :xs="24" :md="8">
            <div class="form-item">
              <label class="w-100">Archivado</label>
              <div class="project-switch-item">
                <el-switch v-model="projectModel.archived" active-text="Si" inactive-text="No"
                  :disabled="!canEditProjectConfigFields" />
              </div>
            </div>
          </el-col>
          <el-col v-if="hasLastReviewDate" :xs="24" :md="8">
            <div class="form-item date-picker">
              <label class="w-100">Ultima revision</label>
              <el-date-picker v-model="projectModel.lastReviewDate" type="date" placeholder="Fecha revision"
                class="w-100 readOnlyInput" format="DD/MM/YYYY" :prefix-icon="'el-icon-date'"
                :picker-options="{ firstDayOfWeek: 1 }" :readonly="true" />
            </div>
          </el-col>
          <el-col v-if="canShowDeleteProject" :xs="24" :md="hasLastReviewDate ? 24 : 8" class="project-delete-column">
            <div class="form-item project-delete-action">
              <button type="button" class="btn btn-block btn_red m-2 btn-action" @click="onDeleteProject">
                Eliminar
              </button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-row>

    <el-row>
      <el-col :xs="24" :md="24" class="label-common">
        <label>Observaciones</label>
        <textarea v-model="projectModel.observations" class="w-100 p-3" rows="5" @change="onChangeObs" />
      </el-col>
    </el-row>

    <el-row v-if="!isCreateMode" class="project-details-row">
      <el-col :xs="24" :md="14">
        <div class="d-flex flex-column">
          <div class="project-info-row d-flex row align-items-center label-common mt-2">
            <div class="col-md-6 col-12 align-self-start project-info-row__item">
              <label class="w-75">Ultima sincronizacion</label>
              <el-date-picker v-model="projectModel.lastSynchronization" :name="'from-date'" type="datetime"
                placeholder="Fecha Inicio" format="DD-MM-YYYY HH:mm:ss" :prefix-icon="'el-icon-date'"
                :picker-options="{ firstDayOfWeek: 1 }" :readonly="true"
                class="pr-3 project-info-input readOnlyInput" />
            </div>
            <div class="col-md-6 col-12 project-info-row__item">
              <div class="form-item">
                <label>Propuesta</label>
                <div class="border bg-white h-auto p-2 pl-5 project-file-box" style="border-radius: 16px;">
                  <span v-if="documentProposal[0] && documentProposal[0].name" class="pointer text-primary"
                    @click="showFile(documentProposal[0])">
                    {{ documentProposal[0].name }}
                  </span>
                  <p v-else>
                    No tiene adjuntos asociados
                  </p>
                </div>
                <button class="btn btn_yellow btn-assign mt-2" @click="selectFile('proposal')">
                  Seleccione...
                </button>
              </div>
            </div>
          </div>
          <div class="project-info-row d-flex row align-items-center label-common mt-4">
            <div class="col-md-6 col-12 align-self-start project-info-row__item">
              <label class="w-75">Horas consumidas</label>
              <el-input v-model="consumedTime" class="pr-3 project-info-input readOnlyInput" :color="'light'"
                :placeholder="'0.00%'" :readonly="true" style="width: 90%;" />
            </div>
            <div class="col-md-6 col-12 project-info-row__item">
              <div class="form-item">
                <label>Estimacion</label>
                <div class="border bg-white h-auto p-2 pl-5 project-file-box" style="border-radius: 16px;">
                  <span v-if="documentEstimate[0] && documentEstimate[0].name" class="pointer text-primary"
                    @click="showFile(documentEstimate[0])">
                    {{ documentEstimate[0].name }}
                  </span>
                  <p v-else>
                    No tiene adjuntos asociados
                  </p>
                </div>
                <button class="btn btn_yellow btn-assign mt-2" @click="selectFile('estimate')">
                  Seleccione...
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="false" class="d-flex row align-items-center mt-2 w-50">
          <button class="btn btn-block btn_red m-2 btn-add" @click="showModalAddEmployee = true">
            Anadir empleado al proyecto
          </button>
        </div>
      </el-col>
      <el-col :xs="24" :md="10">
        <div class="d-flex justify-content-end label-common project-metric">
          <div class="project-metric__label-group align-self-end mb-4 pb-3">
            <label>% Horas consumidas</label>
            <span v-if="projectModel.status" :class="['project-status-badge', projectStatusClass]">
              {{ projectStatusLabel }}
            </span>
          </div>
          <div class="text-porciento ml-4">
            {{ consumedTimePercent }}
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="d-flex justify-content-end mt-5 project-actions">
      <button class="btn btn-block btn_red m-2 btn-action" @click="goBackToProjects">
        Volver
      </button>
      <button type="primary" class="btn btn-block btn_yellow m-2 btn-action" @click="onSubmit">
        {{ isCreateMode ? 'Crear' : 'Guardar' }}
      </button>

      <el-dialog v-if="!isCreateMode" v-model="showModalAddEmployee" :show-close="false" size="medium"
        @closed="closeModalAddEmployee()" width="890" :center="true" :lock-scroll="true" class="project-dialog"
        :style="{ borderRadius: `var(--el-border-radius-round)` }">
        <div class="my-header project-dialog__header">
          <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
            <path
              d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
          </svg>
          <span class="text-header ml-5 mt-3">Anadir Empleados</span>
          <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
            @click="closeModalAddEmployee()">
        </div>
        <div class="my-body">
          <div class="row item-modal">
            <div class="col-sm-12 form-item">
              <label class="modal-add-label">Anadir empleados</label>
              <font-awesome-icon class="btn_icon modal-add-employee-icon" icon="plus-circle" title="Anadir"
                @click="addEmployeeFromConfigModal()" />
            </div>
          </div>

          <div class="row item-modal">
            <div class="col-sm-12">
              <div class="table table-not-mobile">
                <div v-if="selectedProjectList.employees && selectedProjectList.employees.length > 0">
                  <table>
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="employee in selectedProjectList.employees" :key="employee.id">
                        <td>
                          {{ employee.name }} {{ employee.lastName }}
                        </td>
                        <td>
                          <font-awesome-icon class="btn_icon modal-remove-employee-icon" icon="minus-circle"
                            title="Eliminar" @click="addEmployeeToProject(employee)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>
                  <label class="mt-1">No hay empleados todavia...</label>
                </div>
              </div>
              <div class="table-mobile">
                <div v-if="selectedProjectList.employees && selectedProjectList.employees.length > 0">
                  <el-row v-for="employee in selectedProjectList.employees" :key="employee.id" class="mt-2">
                    <el-card class="project-mobile-card w-100">
                      <div class="project-mobile-card__item">
                        <span class="project-mobile-card__label">Nombre:</span>
                        <span>{{ employee.name }} {{ employee.lastName }}</span>
                      </div>
                      <div class="project-mobile-card__actions">
                        <font-awesome-icon class="btn_icon modal-remove-employee-icon" icon="minus-circle"
                          title="Eliminar" @click="addEmployeeToProject(employee)" />
                      </div>
                    </el-card>
                  </el-row>
                </div>
                <div v-else>
                  <label class="mt-1">No hay empleados todavia...</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row item-modal offset-md-3">
            <div class="col-sm-4">
              <button class="btn btn-block btn_red" type="button" @click="closeModalAddEmployee()">
                Cancelar
              </button>
            </div>
            <div class="col-sm-4">
              <button class="btn btn_blue" type="button" @click="requestSaveEmployeeToProject(selectedProjectList)">
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog v-if="!isCreateMode" v-model="showModalEmployees" :title="'Anadir empleados'" size="medium" width="890"
        :center="true" :lock-scroll="true" class="project-dialog"
        :style="{ borderRadius: `var(--el-border-radius-round)` }">
        <div>
          <div class="row modal-item">
            <div class="col-md-9 form-item">
              <el-input v-model="searchNameModalEmployees" label="Nombre" placeholder="Nombre"
                @change="filterEmployeesByName($event)" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="table table-not-mobile">
                <div v-if="listAllEmployees && listAllEmployees.length > 0">
                  <table>
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Departamento</th>
                        <th>Puesto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="employee in listAllEmployees" :key="employee.id" class="pointer"
                        @click="addEmployeeToProject(employee)">
                        <td>
                          {{ employee.name }} {{ employee.lastName }}
                        </td>
                        <td>
                          {{ employee.job ? employee.job.name : null }}
                        </td>
                        <td>
                          {{ employee.job && employee.job.department ? employee.job.department.name : '--' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <SharedElementPagination class="pagination"
                    v-model:current-page="page" :total="allEmployeesListTotal" v-model:page-size="itemsPerPage"
                    style="padding: 0px 0px 20px 0px;" @change="page = $event; getEmployees();" show-always />
                </div>
                <div v-else>
                  <label>No hay empleados disponibles</label>
                </div>
              </div>
              <div class="table-mobile">
                <div v-if="listAllEmployees && listAllEmployees.length > 0">
                  <el-row v-for="employee in listAllEmployees" :key="employee.id" class="mt-2">
                    <el-card class="project-mobile-card w-100 pointer" @click="addEmployeeToProject(employee)">
                      <div class="project-mobile-card__item">
                        <span class="project-mobile-card__label">Nombre:</span>
                        <span>{{ employee.name }} {{ employee.lastName }}</span>
                      </div>
                      <div class="project-mobile-card__item">
                        <span class="project-mobile-card__label">Departamento:</span>
                        <span>{{ employee.job ? employee.job.name : '--' }}</span>
                      </div>
                      <div class="project-mobile-card__item">
                        <span class="project-mobile-card__label">Puesto:</span>
                        <span>{{ employee.job && employee.job.department ? employee.job.department.name : '--' }}</span>
                      </div>
                    </el-card>
                  </el-row>
                  <SharedElementPagination class="pagination"
                    v-model:current-page="page" :total="allEmployeesListTotal" v-model:page-size="itemsPerPage"
                    style="padding: 0px 0px 20px 0px;" @change="page = $event; getEmployees();" show-always />
                </div>
                <div v-else>
                  <label>No hay empleados disponibles</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.name-project {
  font-size: 1em;
  color: #f9156f;
}

.bh-name-hint {
  color: #888;
  margin-top: 4px;
  line-height: 1.4;
  code {
    background: #f0f0f0;
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 0.9em;
  }
}

.text-porciento {
  font-size: 100px;
  font-weight: 900;
  color: #f91570;
}

.label-common {
  label {
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -2px;
  }
}

.card-search {
  border-radius: 15px;
  min-height: 300px;
  height: auto;
  background: url("../../assets/icons/bombilla.png"), white;
  background-size: 24%;
  background-repeat: no-repeat;
  background-position-x: 100%;
  overflow: visible !important;
}

.right {
  float: right;
}

.el-input__inner {
  font-weight: bold;
  border-radius: 150px !important;
}

.btn-action {
  width: 200px;
  height: 40px;
}

.search-input {
  width: 100%;
}

.title-text {
  text-align: left;
  font-size: 3em;
  font-weight: 900;
  letter-spacing: -0.05em;
  color: $font-blue-color;
}

.label {
  margin-top: auto;
}

.btn-add {
  height: 40px;
  font-weight: bold;
  width: 300px;
  min-width: 300px;
}

.my-header {
  margin-top: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .text-header {
    text-align: left;
    font-size: 4em;
    font-weight: 900;
    letter-spacing: -0.05em;
    color: #f9156f;
  }

  .close-icon {
    width: 8%;
    height: 20%;
  }

  .inter-icon {
    width: 2%;
    height: 2%;
  }

  #asterisk {
    position: absolute;
    vertical-align: super;
    height: auto;
    width: 2.2em;
    fill: #f9156f;
  }
}

.my-body {
  margin-right: 5%;
}

.modal-add-employee-icon {
  margin-left: 20px;
  color: green;
}

.modal-add-employee-icon:hover {
  cursor: pointer;
}

.modal-remove-employee-icon {
  color: red;
}

.modal-remove-employee-icon:hover {
  cursor: pointer;
}

.project-header {
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.project-header__title {
  margin-bottom: 0;
}

.project-header__date {
  max-width: 360px;
}

.project-header__date-label {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.project-deadline-badge {
  display: inline-block;
  padding: 0.32rem 0.7rem;
  border-radius: 999px;
  background-color: #E53935;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: normal;
  line-height: 1;
}

.project-date-picker {
  width: 250px;
}

.project-details-row {
  margin-top: 8px;
}

.project-info-row {
  margin-right: 0;
  margin-left: 0;
}

.project-info-row__item {
  margin-bottom: 16px;
}

.project-info-input {
  width: 100%;
}

.project-file-box {
  min-height: 60px;
  word-break: break-word;
}

.project-metric {
  height: 100%;
  align-items: center;
}

.project-metric__label-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.project-status-badge {
  display: inline-block;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: normal;
  line-height: 1;
}

.project-status-badge--ok {
  background-color: #27ae60;
}

.project-status-badge--warning {
  background-color: #f1c40f;
  color: #000;
}

.project-status-badge--danger {
  background-color: #E53935;
}

.project-status-badge--neutral {
  background-color: #107DDE;
}

.project-actions {
  flex-wrap: wrap;
}

.project-delete-action {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
}

.project-delete-column {
  display: flex;
  align-items: flex-end;
}

.project-switch-item {
  display: flex;
  align-items: center;
  min-height: 42px;
}

.table-mobile {
  display: none;
}

.project-mobile-card {
  border-radius: 18px;
}

.project-mobile-card__item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
  word-break: break-word;
}

.project-mobile-card__item:last-child {
  margin-bottom: 0;
}

.project-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

.project-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
}

.project-dialog :deep(.el-dialog) {
  width: min(890px, 94vw) !important;
}

.readOnlyInput {
  cursor: default !important;
}

.readOnlyInput :deep(.el-input__wrapper),
.readOnlyInput :deep(.el-select__wrapper) {
  background-color: #fff !important;
}

.readOnlyInput :deep(*) {
  cursor: default !important;
}

.readOnlyInput :deep(.el-input__wrapper),
.readOnlyInput :deep(.el-date-editor),
.readOnlyInput :deep(.el-date-editor .el-input__wrapper),
.readOnlyInput :deep(.el-date-editor .el-input__inner),
.readOnlyInput :deep(.el-select__wrapper),
.readOnlyInput :deep(.el-select .el-input__wrapper),
.readOnlyInput :deep(.el-input__inner) {
  color: black !important;
  cursor: default !important;
}

:deep(.readOnlyInput.el-date-editor),
:deep(.readOnlyInput.el-date-editor *),
:deep(.readOnlyInput.el-date-editor input),
:deep(.readOnlyInput.el-date-editor input[readonly]),
:deep(.readOnlyInput.el-date-editor .el-input__inner),
:deep(.readOnlyInput.el-date-editor .el-input__wrapper) {
  cursor: default !important;
}

:deep(.readOnlyInput.el-date-editor .el-input__wrapper) {
  background-color: #fff !important;
  overflow: hidden;
}

:deep(.readOnlyInput.el-date-editor .el-input__inner),
:deep(.readOnlyInput.el-date-editor input),
:deep(.readOnlyInput.el-date-editor input[readonly]) {
  background-color: transparent !important;
}

.readOnlyInput :deep(.el-input__prefix),
.readOnlyInput :deep(.el-input__suffix),
.readOnlyInput :deep(.el-input__prefix-inner),
.readOnlyInput :deep(.el-input__suffix-inner) {
  cursor: default !important;
}

.readOnlyInput :deep(.el-select__placeholder),
.readOnlyInput :deep(.el-select__selected-item),
.readOnlyInput :deep(.el-select .el-input__inner),
.readOnlyInput :deep(.el-select__wrapper),
.readOnlyInput :deep(.el-select__wrapper.is-disabled),
.readOnlyInput :deep(.el-select__wrapper.is-disabled .el-select__placeholder),
.readOnlyInput :deep(.el-select__wrapper.is-disabled .el-select__selected-item) {
  color: #000 !important;
  -webkit-text-fill-color: #000 !important;
}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {

  .label-common,
  .project-details-row,
  .project-actions {
    padding-right: 14px;
  }

  .project-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .project-header__title {
    width: 100% !important;
    padding: 0;
    font-size: 2.1em;
  }

  .project-header__date {
    width: 100%;
    max-width: none;
    padding: 0;
  }

  .project-date-picker {
    width: 100%;
  }

  .card-search {
    height: auto;
    padding: 18px 16px;
    background-size: 96px;
    background-position: calc(100% + 24px) 12px;
  }

  .text-porciento {
    font-size: 56px;
    line-height: 1;
  }

  .project-metric {
    justify-content: flex-start !important;
    margin-top: 8px;
  }

  .project-metric__label-group {
    align-items: flex-start;
  }

  .project-metric label {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .project-info-row {
    margin-top: 0 !important;
  }

  .project-info-row__item {
    padding-left: 0;
    padding-right: 0;
  }

  .project-info-row__item .form-item,
  .project-info-row__item .project-info-input,
  .project-info-row__item .btn-assign,
  .label-common textarea {
    margin-right: 0;
  }

  .project-file-box {
    padding-left: 16px !important;
    margin-right: 0;
  }

  .project-actions {
    flex-direction: column-reverse;
    align-items: stretch !important;
  }

  .project-actions .btn-action {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .project-delete-action .btn-action {
    width: 200px;
  }

  .my-header .text-header {
    font-size: 2em;
    padding-left: 24px;
  }

  .my-header .close-icon {
    width: 24px;
    height: 24px;
  }

  .my-body {
    margin-right: 0;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
  }
}
</style>
